__turbopack_context__.v({
  "root": "Margin-module-scss-module__nAvMZa__root",
});
